enum PreferenceConfidence {
  InsufficientData,
  VeryConfident,
  Confident,
  FairlyConfident,
  NoStatisticalSignificance,
}
export default PreferenceConfidence
